import { fromZonedTime } from 'date-fns-tz';

import { envStatus } from '@/react/portainer/environments/update-schedules/DetailsView/envStatus';
import { ScheduleEnvironment } from '@/react/portainer/environments/update-schedules/DetailsView/types';
import { UpdateTimeline } from '@/react/portainer/environments/update-schedules/DetailsView/UpdateTimeline';

import { Divider } from '@@/Divider/Divider';
import { Widget, WidgetBody, WidgetTitle } from '@@/Widget';

import { formatDate, parseEnvironmentTimezone } from '../common/utils';

import { duration } from './utils';

interface Props {
  title?: string;
  scheduleEnvironment?: ScheduleEnvironment;
}

export function EnvironmentDetailsWidget({
  title,
  scheduleEnvironment,
}: Props) {
  if (!scheduleEnvironment) {
    return null;
  }
  // Use the user's (browser's) timezone directly
  const { timeZone } = Intl.DateTimeFormat().resolvedOptions();

  const environmentTimeZone = parseEnvironmentTimezone(
    scheduleEnvironment.environment.LocalTimeZone
  );
  const zonedDate = fromZonedTime(
    scheduleEnvironment?.scheduledTime ?? '',
    environmentTimeZone
  );

  return (
    <Widget aria-label="ariaLabel" id="id-test">
      <WidgetTitle title={title} className="text-lg font-semibold">
        {scheduleEnvironment && envStatus(scheduleEnvironment)}
      </WidgetTitle>
      <WidgetBody className="form-horizontal !ml-1">
        <div className="text-sm flex flex-col gap-4">
          <div className="flex flex-wrap justify-between">
            <div>{formatDate(zonedDate, timeZone)}</div>
            <div>{duration(scheduleEnvironment)}</div>
          </div>
        </div>
      </WidgetBody>
      <Divider length="95%" />
      <WidgetBody className="form-horizontal !ml-1">
        <div className="text-sm">
          <h5 className="m-0 ml-0 mb-6">Status</h5>
          <UpdateTimeline scheduleEnvironment={scheduleEnvironment} />
        </div>
      </WidgetBody>
    </Widget>
  );
}
